import * as R from 'ramda'
import Moment from 'moment'

interface IEvent {
  city: string
  contact_name: string
  country: string
  description: string
  email: string
  end_data: string
  is_ongoing: string
  name: string
  province: string
  seqn: string
  start_date: string
  url: string
  venue: string
  volunteers_needed: string
}

const events = (
  state: any = { seqn: null },
  action: any
) => {
  switch (action.type) {
    case 'GET_EVENTS_REQUESTED':
      return {
        ...state,
        status: 'loading'
      }
    case 'GET_EVENTS_ERROR':
      return {
        ...state,
        status: 'Error',
        error: action.payload
      }
    case 'GET_EVENTS_SUCCESS':
      // group data by Month-Year
      const byMonthYear = R.groupBy((event: IEvent) => {
        const eventStartDate = Moment(event.start_date)
        return `${eventStartDate.format('MMMM')} ${eventStartDate.format(
          'YYYY'
        )}`
      })

      // events grouped by month
      let eventsByMonth = R.toPairsIn(
        byMonthYear(action.payload.filter(item => item.is_ongoing === false))
      )
      const ongoing = [
        'Ongoing',
        action.payload.filter(item => item.is_ongoing === true)
      ]

      eventsByMonth.unshift(ongoing)
      return {
        ...state,
        data: eventsByMonth,
        status: 'success'
      }
    default:
      return state
  }
}

export default events
